import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FiltersPagination from "../../../components/elements/FiltersPagination";
import DataTableElement from "../../../components/elements/DataTableElement";

import ConfirmDeleteModal from "../../../components/modal/ConfirmDeleteModal";
import { Columns } from "./Columns";
import { iaElementsResource, servicesOrderAISave } from "../../../helpers/configRoutes/backend_helper";
import AddUpServiceOrder from "./AddUpServiceOrder";
import { useDispatch } from "react-redux";
import { reset_service, update_service } from "../../../store/serviceOrders/action";

const ServiceOrdersPre = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [selectedRows, setSelectedRows] = useState([]);
    const [filters, setFilters] = useState({ endDate: '', startDate: '', search: '', from: 0, to: 0, page: 1, truck: true });
    const [load, setLoad] = useState({ show: false, textLoad: 'Loading accounts...' });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [item, setItem] = useState({});
    const [data, setData] = useState([]);
    const [modalConfirm, setModalConfirm] = useState({ show: false, title: 'Delete Truck', loadig: false, textLoad: 'Processing' })
    const [modal, setModal] = useState({ show: false, title: 'New Service' })
    const deleteTrailerTruck = async () => {
        setModalConfirm({ ...modalConfirm, loading: true })
        // const response = await trailerTrucksResource('del', {}, modalConfirm.id);
        // if (response.status) {
        //     setFilters({ ...filters })
        // }
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null })
    }

    useEffect(() => {
        const getData = async () => {
            setLoad({ ...load, show: true })
            const response = await iaElementsResource('show', {}, id);
            setData(response.element.ia_response);
            setLoad({ ...load, show: false })
            setItem(response.element)
        };
        getData();
    }, [filters]);

    const formatedDate = (dateRec) => {
        const date = new Date(dateRec);
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // meses de 0 a 11, por eso +1
        const dd = String(date.getDate()).padStart(2, '0');

        const formatted = `${yyyy}-${mm}-${dd}`;
        return formatted; // ej. "2025-06-02"
    }

    const openModalAdd = (serviceOrderItem = {}) => {
        serviceOrderItem.truck_id = item.makeable_id
        serviceOrderItem.internalId = serviceOrderItem.id
        serviceOrderItem.creation_date = formatedDate(new Date())
        serviceOrderItem.due_date = serviceOrderItem.proposed_date
        serviceOrderItem.mileage_control = serviceOrderItem.is_recurring ? 1 : 0
        serviceOrderItem.miles_interval_truck = serviceOrderItem.milleage_recurrent
        
        dispatch(serviceOrderItem.id ? update_service(serviceOrderItem) : reset_service())
        setModal({
            ...modal,
            show: true,
            title: serviceOrderItem.id ? "Edit Service Order" : "Add Service Order",
        });
    };

    const handleGuardar = async() => {
        const response = await servicesOrderAISave({selectedRows:selectedRows,element:item})
        if(response.status){
            navigate('/ai-operations')
        }
    }

    const cols = Columns(selectedRows, setSelectedRows, openModalAdd,item)
    return (
        <div className="p-8">
            {/* Header con título y botón Guardar condicional */}
            <div className="flex justify-between items-center mb-4">
                <div className="text-2xl font-semibold">Service Orders</div>
                {selectedRows.length > 0 && (
                    <button
                        onClick={handleGuardar}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Guardar
                    </button>
                )}
            </div>

            <div className="bg-white shadow-md rounded-lg">
                <DataTableElement
                    columns={cols}
                    items={data}
                    tableLoad={load}
                />
            </div>

            {modal.show && (
                <AddUpServiceOrder
                    modal={modal}
                    setModal={setModal}
                    data={data}
                    setData={setData}
                />
            )}
        </div>
    );
}

export default ServiceOrdersPre;
